import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Card } from '@arnsbogroup/react-voicearchive'
import classNames from 'classnames'
import { FormattedMessage, FormattedRelativeTime } from 'react-intl'
import messages from './messages'
import DemoPlayButton from 'containers/DemoPlayButton'
import Icon from 'components/Icon'
import genderMessages from 'data/genders/messages'
import useColor from 'hooks/useColor'

const VoiceCompact = ({ voice, onDeselect }) => {
  const color = useColor(voice.sku)

  return (
    <Card
      style={{
        borderLeftColor: color,
        borderLeftWidth: '3px',
      }}
      className={classNames(
        'break-inside-avoid',
        'hover:shadow-md',
        'group',
        'overflow-hidden',
        'truncate',
        'text-sm',
        'p-2',
        'space-y-1',
        'bg-white'
      )}
    >
      <div className="flex justify-between items-center">
        <Link to={voice.sku} className="truncate space-x-1 font-medium">
          {voice.featured && (
            <Icon icon={['fas', 'star']} className="text-tertiary" />
          )}

          <span>{voice.sku}</span>
        </Link>

        <Icon
          icon="times"
          className="text-gray-400 hover:text-primary cursor-pointer"
          onClick={onDeselect}
        />
      </div>

      <div className="flex justify-between items-center">
        <div className="space-x-1 text-xs">
          <FormattedMessage {...genderMessages[voice.gender]} tagName="span" />
          <FormattedMessage
            {...messages.shortAge}
            values={{ age: voice.age }}
            tagName="span"
          />
        </div>

        <div className="space-x-1 text-xs flex items-center">
          {!!voice?.demos.length && (
            <span className="flex-shrink truncate">
              <FormattedMessage
                {...messages.demoCount}
                values={{ count: voice?.demos.length || 0 }}
              />
            </span>
          )}

          {(voice?.demos?.[0] || voice?._demos?.[0]) && 
            <DemoPlayButton
              iconOnly
              voice={voice}
              demo={voice?.demos?.[0] || voice?._demos?.[0]}
              className="flex-shrink-0 p-0 hover:bg-white bg-white hover:text-primary cursor-pointer text-primary "
              childClassName="p-0 text-sm"
            />
          }
        </div>
      </div>
    </Card>
  )
}

export default VoiceCompact
